import useSWR from "swr";

import { UserIndustryMaster } from "@/apis/clients";
import userIndustryMasterApi from "@/apis/master/userIndustryMasterApi";
import { useLoading } from "@/states/loading/operations";

export default function useGetUserIndustries() {
  const withLoading = useLoading();

  const fetcher = async (): Promise<UserIndustryMaster[]> => {
    return new Promise((resolve, reject) => {
      withLoading(async () => {
        const result = await userIndustryMasterApi.getUserIndustries();
        resolve(result);
      }).catch((error) => {
        reject(error);
      });
    });
  };

  const { data, error } = useSWR<UserIndustryMaster[], Error>(
    "/user-industry-master",
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );

  return {
    userIndustries: data,
    userIndustriesError: error,
  };
}
